import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from "../../Images/build.jpg";
import img2 from "../../Images/build2.jpg";
import img3 from "../../Images/build3.jpg";
import img4 from "../../Images/build4.jpg";
import HomeService from "../../Services/HomeService";

const PrevArrow = ({ onClick }) => (
  <button className="slick-arrow11 custom-prev11" onClick={onClick}>
    <i class="fa-solid fa-arrow-left"></i>
  </button>
);

const NextArrow = ({ onClick }) => (
  <button className="slick-arrow11 custom-next11" onClick={onClick}>
    <i class="fa-solid fa-arrow-right"></i>
  </button>
);

const TopProject = () => {
  const [highlightedProjects, setHighlightedProjects] = useState([]);
  const sliderRef = useRef(null);

  const fetchHighlightedProject = async () => {
    try {
      const res = await HomeService?.getHighlightedProject();

      console.log("highlighted projects", res);
      if (res?.status) {
        setHighlightedProjects(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchHighlightedProject();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 700,
    autoplaySpeed: 2000,
    arrows: false,
    // prevArrow: <PrevArrow />,
    // nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const projects = [
    {
      id: 1,
      img: img1,
      title: "Kamalam Vintage",
      by: "by Kamalam Builders",
      type: "2, 3 BHK Apartments",
      location: "Madipakkam, Chennai South",
      price: "₹97.74 L - 1.59 Cr",
    },
    {
      id: 2,
      img: img2,
      title: "Vertex 33 West",
      by: "by Vertex Vega Developers LLP",
      type: "2, 3 BHK Apartments",
      location: "Nallagandla, North Hyderabad",
      price: "₹1.16 Cr – 1.77 Cr",
    },
    {
      id: 3,
      img: img3,
      title: "Forest Heights",
      by: "by GreenBuild",
      type: "3 BHK Premium",
      location: "Salt Lake, Kolkata",
      price: "₹65 L - 95 L",
    },
    {
      id: 4,
      img: img4,
      title: "Lakeview Residency",
      by: "by BlueStone Ltd.",
      type: "2, 3 BHK Apartments",
      location: "Bandra, Mumbai",
      price: "₹1.2 Cr – 2.5 Cr",
    },
  ];

  return (
    <div className="highlight-wrapper1">
      <div className="div_slider11">
        <h2 className="highlight-title11">Top highlighted projects</h2>
        <div className="highligh-sld-bts-wrp">
          <p className="highlight-subtitle11">Noteworthy projects to watch</p>
          <div className="slider-control-btn-wr">
            <button
              onClick={() => sliderRef.current.slickPrev()}
              className="arrow-btn-ws"
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>
            <button
              onClick={() => sliderRef.current.slickNext()}
              className="arrow-btn-ws"
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <div className="highlight-slider-wrap1">
        <Slider ref={sliderRef} {...settings}>
          {highlightedProjects?.map((p) => (
            <div key={p.id} className="project-card11">
              <div className="project-img-box11">
                <img src={p?.image} alt={p.title} className="project-img11" />

                <div className="project-overlay11">
                  <h3 className="project-title11">{p?.title}</h3>
                  <p className="project-builder11">{p?.shortDescription}</p>

                  <div className="project_under11">
                    <div className="project_under1">
                      <p className="project-type11">
                        {/* {p?.propertytype?.propertyType} */}
                      </p>
                      {/* <p className="project-location11">{p?.city?.name}</p> */}
                    </div>
                    <p className="project-price11">{p?.price}</p>
                  </div>
                </div>

                <div className="overlay-gradient11"></div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TopProject;
